function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Object.prototype.toString.call(value) === '[object Object]';
}

function toCamelKey(key: string) {
  return key.length > 0 ? key[0].toLowerCase() + key.slice(1) : key;
}

export function normalizeApiPayload<T>(input: T): T {
  if (Array.isArray(input)) {
    return input.map(item => normalizeApiPayload(item)) as T;
  }

  if (isPlainObject(input)) {
    const output: Record<string, unknown> = {};

    Object.entries(input).forEach(([key, value]) => {
      output[toCamelKey(key)] = normalizeApiPayload(value);
    });

    return output as T;
  }

  return input;
}
